<script setup lang="ts">
import FullProduct from '~/models/Product/FullProduct'
import { useBasketStore } from '~/stores/basket'
import { GtmItemListNameEnum } from '~/models/DataLayer/GtmItemListNameEnum'
import { LuigisBoxClickEventTypeEnum } from '~/models/LuigisBox/LuigisBoxClickEventTypeEnum'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'

const props = defineProps({
    productData: {
        type: Object as PropType<FullProduct>,
        required: true,
    },
    fixedPosition: {
        type: Boolean,
        default: false,
    },
})

const showClickAndCollect = computed(() => {
    return false // return props.productData.clickAndCollectData?.showExpresButton
})

const actualUnitPrice = computed(() => {
    const basketStore = useBasketStore()

    if (basketStore.productUnitPrices[props.productData.id]) {
        return basketStore.productUnitPrices[props.productData.id].price
    }

    return props.productData.price
})

const itemListName = GtmItemListNameEnum.ProductDetail

const lowestPriceInAmountPrices = computed(() => {
    if (props.productData.amountPrices.length === 0) {
        return null
    }

    const highestAmountElement = props.productData.amountPrices.reduce((prev, curr) => (prev.from > curr.from ? prev : curr))

    return highestAmountElement.price
})

const sendLuigisboxEvent = (productUrl: string) => {
    LuigisBoxEventApi.sendClickEvent(LuigisBoxClickEventTypeEnum.Conversion, productUrl)
}

const authUser = computed(() => {
    const basketStore = useBasketStore()

    return basketStore.authUser
})
</script>

<template>
    <div class="respo-wrapper" :class="{ 'add-wrapper-detail': fixedPosition }">
        <div class="product-price-container">
            <ElementsProductCardPrice
                :has-super-price="productData.attributes.hasSuperPrice"
                :has-competitor-super-price="productData.hasCompetitorSuperPrice"
                :price="productData.price"
                :price-before-discount="productData.priceBeforeDiscount"
                :addon-sale-behavior="false"
                :addon-sale-price="productData.attributes.addonSalePrice || null"
                :price-from="lowestPriceInAmountPrices"
                :size="fixedPosition ? 'l' : 'xl'"
            />
        </div>
        <!--        <UiSuperPrice-->
        <!--            v-if="productData.attributes.hasSuperPrice && !productData.pharmacyDealPrice"-->
        <!--            :price-before="productData.priceBeforeDiscount || 0"-->
        <!--            :price-actual="actualUnitPrice"-->
        <!--            :lowest-price="productData.lowestPrice"-->
        <!--        />-->
        <!--        <ElementsCompetitorSuperPrice-->
        <!--            v-else-if="productData.hasCompetitorSuperPrice && !productData.pharmacyDealPrice"-->
        <!--            :show-add-button="productData.productVariants.variantsCount === 0"-->
        <!--            :product="(productData as unknown) as Product"-->
        <!--        />-->
        <!--        <div v-else class="pharmacy-price-block notranslate">-->
        <!--            <UiPriceInPharmacy v-if="productData.pharmacyDealPrice && !fixedPosition" :price="productData.pharmacyDealPrice" />-->
        <!--            <div class="block-price">-->
        <!--                <div v-if="lowestPriceInAmountPrices">-->
        <!--                    <span class="price-before me-1 d-inline-block notranslate">-->
        <!--                        <s v-html="$formatCurrency(productData.priceBeforeDiscount || productData.price)"></s>-->
        <!--                    </span>-->
        <!--                    <span-->
        <!--                        class="price ml-2 d-inline-block"-->
        <!--                        v-html="`${$t('header.from')} ${$formatCurrency(lowestPriceInAmountPrices)}`"-->
        <!--                    ></span>-->
        <!--                </div>-->
        <!--                <div v-else>-->
        <!--                    <span v-if="productData.priceBeforeDiscount" class="price-before me-1 notranslate">-->
        <!--                        <s v-html="$formatCurrency(productData.priceBeforeDiscount)"></s>-->
        <!--                    </span>-->
        <!--                    <span class="price notranslate" v-html="$formatCurrency(actualUnitPrice)"></span>-->
        <!--                </div>-->
        <!--                <span-->
        <!--                    v-if="productData.deposit"-->
        <!--                    class="deposit-price notranslate"-->
        <!--                    v-html="`${$t('productDetail.plusDeposit')} ${$formatCurrency(productData.deposit)}`"-->
        <!--                >-->
        <!--                </span>-->
        <!--            </div>-->
        <!--        </div>-->
        <div
            v-if="productData.attributes.comparablePrice && !fixedPosition"
            class="price-perunit"
            v-html="productData.attributes.comparablePrice"
        ></div>
        <div v-if="productData.productVariants.variantsCount === 0" class="product-buttons" :class="{ grid: showClickAndCollect }">
            <ObjectsTextTooltip
                v-if="productData.isPremiumExclusive && !authUser?.isPremium"
                :text="$t('product.premiumFromXPerMonth')"
                placement="bottom"
            >
                <nuxt-link class="btn btn-primary mt-2 mb-2" to="/pilulka-premium">
                    {{ $t('productDetail.moreAboutPilulkaPremium') }}
                </nuxt-link>
            </ObjectsTextTooltip>
            <ElementsButtonAddBasket
                v-else
                :class="fixedPosition || $device.isDesktop ? 'add-cart__container--lg' : 'add-cart__container--max'"
                :add-basket-align="''"
                :full-product="productData"
                :product-id="productData.id"
                :product-price="actualUnitPrice"
                :is-preorder="productData.isPreorder"
                :max-amount-per-order="productData.attributes.maxAmountPerOrder"
                :has-substitution-modal="productData.substitutions?.isModal || false"
                :item-list-name="itemListName"
                :show-actual-state-mode="fixedPosition ? 'hidden' : 'big'"
                button-class="btn-primary w-100 py-1"
                @product-added-to-basket="sendLuigisboxEvent"
            />
            <ElementsClickAndCollect v-if="showClickAndCollect" class="click-and-collect_container" :product="productData" />
        </div>
        <nuxt-link v-else class="btn-variants btn btn-primary btn-sm" to="{ hash: '#service-variants' }">
            {{ $t('productDetail.selectVariant') }}
        </nuxt-link>
    </div>
</template>

<style lang="scss" scoped>
.product-price-container {
    display: block;

    @include screen-md {
        text-align: left;
        margin-bottom: 10px;
    }
}
@include screen-sm {
    .respo-wrapper .add-cart__stock {
        text-align: right;
    }
}

.block-price {
    min-width: 50%;
}

@include screen-sm {
    .respo-wrapper .counter {
        display: block;
    }
}

.respo-wrapper .add-cart {
    border-radius: 50px;
}

@media (max-width: 768px) {
    .respo-wrapper {
        display: flex;
        justify-content: space-between;
        gap: 10px;
        flex-direction: column;
        margin-top: 19px;

        .add-cart__stock {
            text-align: center;
        }

        .add-cart__container--lg {
            max-width: 155px;
            flex: 1;
        }

        .add-cart {
            width: auto;
            margin-right: 0;
        }

        &.full {
            display: block;
            padding-bottom: 75px;

            .add-cart__container {
                margin-top: 10px;
                max-width: 100%;
            }
        }

        .popper {
            top: -117px;
        }
    }
}

@media (max-width: 768px) {
    .add-wrapper-detail {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        background: #ffeef6;
        padding: 10px 15px 85px;
        box-shadow: 0px -4px 4px -2px rgba(0, 0, 0, 0.08);
        z-index: 299;
        flex-direction: row;
        align-content: center;

        .block-price {
            min-width: 160%;
        }
    }
}

.price {
    font-weight: 700;
    color: $color-cta;
    min-width: 100px;
    display: block;

    @media (min-width: 480px) {
        font-size: 28px;
    }
}

.price-before {
    font-size: 1.2em;

    @media (min-width: 480px) {
        font-size: 18px;
    }
}

.price {
    font-size: 1.2em;

    @media (min-width: 480px) {
        font-size: 26px;
    }
}

.price-perunit {
    color: $color-grey-extra-dark;
    font-size: 12px;
    padding-bottom: 10px;
}

.pharmacy-price-block {
    display: flex;
    gap: 1rem;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;

    .price-in-pharmacy {
        margin: 0;
    }

    .block-price {
        margin-bottom: 0;
    }
}
</style>
